// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';

const MailReceived: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription } = notification;
  return (
    <Text>
      <Text span weight="bolder">
        {personDescription}
      </Text>
      {'  '}
      hat Dir geschrieben.
    </Text>
  );
};

export default MailReceived;
